import React, { FC } from 'react';
import { Tabs } from 'src/common/form/tabs';
import OrganizationLink from 'src/common/OrganizationLink';
import { functionNoop } from 'src/utils/function/noop';
import { DashboardInsightsTabType } from './constants';

type DashboardInsightsTabsProps = {
  activeTab: DashboardInsightsTabType;
};

export const DashboardInsightsTabs: FC<DashboardInsightsTabsProps> = ({ activeTab }) => {
  return (
    <Tabs
      theme='bedrock'
      value={activeTab}
      onChange={functionNoop}
      options={[
        {
          value: 'content',
          label: (
            <OrganizationLink to={`/insights/content`} className='flex'>
              Content
            </OrganizationLink>
          ),
        },
        {
          value: 'journeys',
          label: (
            <OrganizationLink to={`/insights/journeys`} className='flex'>
              Journeys
            </OrganizationLink>
          ),
        },
      ]}
    />
  );
};
